import { getAPI } from "../api_routes/base";

export const userInfo = async () => {
  const response = await getAPI().get("/auth/user-info", {
    withCredentials: true,
  });
  return response.data;
};
